<template>
  <div>
    <v-card>
      <v-card-title>AquaDuct Roof & Gutters</v-card-title>
      <v-card-subtitle>What our customers say</v-card-subtitle>
      <v-card-text>AquaDuct is great!</v-card-text>
      <v-card-actions>buttons</v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "guild-quality",
};
</script>

<style lang="scss" scoped></style>
